import React, { useEffect } from 'react';
import { defineMessages, injectIntl, IntlShape } from 'react-intl';
import { StyledToggleInput } from './styled';
import Connector, { PropsFromRedux } from './Connector';
import { LOCAL_STORAGE_ITEMS } from 'src/utils/constants';
import { hasAnyPermissions } from 'src/utils/permissions';
import permissions from 'src/permissions';

type Props = PropsFromRedux & { intl: IntlShape };
const PatientToggleNames = ({
  intl,
  displayPatientNames,
  changeViewPatientNames,
}: Props) => {
  useEffect(() => {
    if (!hasAnyPermissions(permissions.VIEW_PATIENTS_NAMES_TOGGLE_BUTTON)) {
      changeViewPatientNames(true);
      sessionStorage.removeItem(LOCAL_STORAGE_ITEMS.display_patient_names);
      return;
    }
    changeViewPatientNames(
      sessionStorage.getItem(LOCAL_STORAGE_ITEMS.display_patient_names) ===
        'true',
    );
  }, []);

  return hasAnyPermissions(permissions.VIEW_PATIENTS_NAMES_TOGGLE_BUTTON) ? (
    <StyledToggleInput
      className={'toggle-normal-size'}
      checked={displayPatientNames}
      label={intl.formatMessage(messages.toggleLabel)}
      onChange={e => {
        const isChecked = e.target.checked;
        changeViewPatientNames(isChecked);
        sessionStorage.setItem(
          LOCAL_STORAGE_ITEMS.display_patient_names,
          isChecked.toString(),
        );
      }}
    />
  ) : (
    <></>
  );
};
const messages = defineMessages({
  toggleLabel: {
    id: 'PatientToggleNames.index.toggleLabel',
    defaultMessage: 'With patient names',
  },
});

export default Connector(injectIntl(PatientToggleNames));
